export default "__VITE_ASSET__BsugPfzc__"